

















































import { defineComponent, computed } from '@vue/composition-api';
import { useQuery, useResult } from '@vue/apollo-composable';

import getDataForGroupAddress from '@/gql/thaiLocation/getDataForGroupAddress.gql';

import CommonProvinceSelector from '@/components/LocationAddress/CommonProvinceSelector.vue';
import CommonDistrictSelector from '@/components/LocationAddress/CommonDistrictSelector.vue';
import CommonSubdistrictSelector from '@/components/LocationAddress/CommonSubdistrictSelector.vue';

const GroupAddressEditor = defineComponent({
  setup(props: any, context: any) {
    const getDataForGroupAddressQuery = useQuery(getDataForGroupAddress, {
      fetchPolicy: 'cache-and-network',
    });
    const provinces = useResult(getDataForGroupAddressQuery.result, [], (data: any) => data.provinces);

    const districts = computed(() => {
      if (!props.value.province) return [];
      const filteredProvince = provinces.value.find((province: any) => String(province.id) === String(props.value.province.id));
      if (filteredProvince && filteredProvince.districts) return filteredProvince.districts;
      return [];
    });

    const subdistricts = computed(() => {
      if (!props.value.district) return [];
      const filteredDistrict = districts.value.find((district: any) => String(district.id) === String(props.value.district.id));
      if (filteredDistrict && filteredDistrict.subdistricts) return filteredDistrict.subdistricts;
      return [];
    });

    function onUpdate(type: string, newValue: string | number) {
      if (type === 'province') {
        context.emit('input', {
          ...props.value,
          province: { id: newValue },
          district: { id: null },
          subdistrict: { id: null },
        });
      } else if (type === 'district') {
        context.emit('input', {
          ...props.value,
          district: { id: newValue },
          subdistrict: { id: null },
        });
      } else if (type === 'subdistrict') {
        context.emit('input', {
          ...props.value,
          subdistrict: { id: newValue },
          zipcode: (subdistricts?.value.find((subdistrict: any) => subdistrict?.id === newValue)).zipcode,
        });
      } else if (type === 'postcode') {
        context.emit('input', {
          ...props.value,
          zipcode: newValue,
        });
      } else if (type === 'address') {
        context.emit('input', {
          ...props.value,
          address: newValue,
        });
      } else {
        context.emit('input', {
          province: null,
          subdistrict: null,
          district: null,
          address: '',
          zipcode: '',
        });
      }
    }

    return {
      districts,
      subdistricts,
      onUpdate,
    };
  },
  props: {
    value: {}, // address object
    level: {},
    label: { default: 'ที่อยู่' },
    showLabel: { default: true },
    margin: { default: true },
    requiredAddress: { default: false },
    requiredProvince: { default: false },
    requiredDistrict: { default: false },
    requiredSubdistrict: { default: false },
    requiredPostcode: { default: false },
    emitAsString: { default: false },
  },
  components: {
    CommonProvinceSelector,
    CommonDistrictSelector,
    CommonSubdistrictSelector,
  },
});

export default GroupAddressEditor;
